import { useState } from 'react';

export const useStillBuilding = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values, onStillBuilding) => {
    setLoading(true);
    setError(null);
    try {
      await onStillBuilding(values);
    } catch (err) {
      setError('Error creating account. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
  };
};
